import React, { useEffect, useState } from "react";
import { IoWarning } from "react-icons/io5";
import "../../css/items.scss";
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import AnnualMeeting from "./AnnualMeeting";
import AnnualMeetingArchive from "./AnnualMeetingArchive";
import "./meeting.scss";

const Meeting = ({ data, language }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeSection, setActiveSection] = useState("overview");
  const [current, setCurrent] = useState(null);
  const [archive, setArchive] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const getLatestMeeting = (id) => {
    serverInstance.post("/app/item", { class: "meeting", id: id }, {
      headers: {
        "Content-Type": "application/json",
      }
    })
      .then(res => {
        const item = res.data.item;
        item.speakers = res.data?.speakers;
        item.sponsors = res.data?.sponsors;
        item.rows = res.data?.rows;
        setCurrent(item)
      })
  }

  useEffect(() => {
    serverInstance.get("/app/meetings")
      .then(res => {
        let data = res.data.items.filter(item => !item.test)
        data.sort((a, b) => new Date(b.dt).getTime() - new Date(a.dt).getTime())
        setArchive(data.slice(1))
        setErrorMsg("");
        setCurrent(data[0]);
        setLoading(false);
        getLatestMeeting(data[0].id)
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })

    setTimeout(() => {
      window.scrollTo(0, 0); 
    });
  }, []);

  const hasSpeakers = (current?.speakers || []).length > 0;
  const hasAgenda = (current?.rows || []).length > 0;
  const showSubNav = activeTab === 0 && current;

  const handleMainTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    if (tabIndex === 0) {
      setActiveSection("overview");
    }
  };

  return (
    <div className='meeting-container items-container d-flex flex-column align-items-center '>
      <div className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>
        </div>
      </div>

      {loading ? <Dimmer /> : null}

      {errorMsg ? <div className="error-msg">
        <IoWarning />
        &nbsp;
        {errorMsg}
      </div> : null}

      <section className="meeting-main">
        <div className="tabs">
          <div className={'tab-item' + (0 === activeTab ? " active" : "")}
            onClick={() => handleMainTabClick(0)}>
{language ? (current?.title_en && current?.title_en.trim() ? current?.title_en : current?.title) : current?.title}
          </div>
          <div className={'tab-item' + (1 === activeTab ? " active" : "")}
            onClick={() => handleMainTabClick(1)}>
            {data.archive}
          </div>
        </div>
        {showSubNav ? (
          <nav className="meeting-subnav" aria-label={language ? "Meeting sections" : "Хуралын хэсгүүд"}>
            <button
              type="button"
              className={"meeting-subnav-link" + (activeSection === "overview" ? " active" : "")}
              onClick={() => setActiveSection("overview")}
            >
              {data.registrationNav}
            </button>
            {hasSpeakers ? (
              <button
                type="button"
                className={"meeting-subnav-link" + (activeSection === "speakers" ? " active" : "")}
                onClick={() => setActiveSection("speakers")}
              >
                {data.presenters}
              </button>
            ) : null}
            {hasAgenda ? (
              <button
                type="button"
                className={"meeting-subnav-link" + (activeSection === "agenda" ? " active" : "")}
                onClick={() => setActiveSection("agenda")}
              >
                {data.agenda}
              </button>
            ) : null}
          </nav>
        ) : null}
        <div className="meeting-content">
          {activeTab === 0 ?
            <AnnualMeeting
              data={data}
              item={current}
              language={language}
              contentView={activeSection}
            />
          : activeTab === 1 ?
            <AnnualMeetingArchive data={data} items={archive} language={language}/>
          : null}
        </div>
      </section>
    </div>
  );
};
export default Meeting;
